require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-michele-arnaboldi.json") })
        }
      }, "path---en-interviste-michele-arnaboldi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-michele-arnaboldi!./.cache/json/en-interviste-michele-arnaboldi.json
// module id = 594
// module chunks = 231608221292675